"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var chart_js_1 = require("chart.js");
var chartjs_chart_sankey_1 = require("chartjs-chart-sankey");
chart_js_1.Chart.register.apply(chart_js_1.Chart, __spreadArrays(chart_js_1.registerables, [chartjs_chart_sankey_1.SankeyController, chartjs_chart_sankey_1.Flow]));
var SankeyFlow = function (_a) {
    var _b = _a.targetName, targetName = _b === void 0 ? 'Target' : _b, _c = _a.flowCounts, flowCounts = _c === void 0 ? [20, 15, 25, 10, 30, 18, 22] : _c;
    var canvasRef = react_1.useRef(null);
    var chartRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (!canvasRef.current)
            return;
        // Destroy existing chart if it exists
        if (chartRef.current) {
            chartRef.current.destroy();
        }
        var ctx = canvasRef.current.getContext('2d');
        if (!ctx)
            return;
        var flowNames = [
            'Backlog',
            'Qualification',
            'Prioritisation',
            'Definition',
            'Readiness',
            'Implementation',
            'Complete',
        ];
        // Apply minimum visual weight to flows
        var minVisualWeight = 5;
        var flowData = flowNames.map(function (name, index) { return ({
            from: targetName,
            to: name + " (" + flowCounts[index] + ")",
            flow: Math.max(flowCounts[index], minVisualWeight),
        }); });
        var data = {
            datasets: [
                {
                    label: 'Flow Dataset',
                    data: flowData,
                    colorFrom: function () {
                        return '#f1f1f1';
                    },
                    colorTo: function (c) {
                        var colors = [
                            '#888888',
                            '#671E75',
                            '#E57200',
                            '#B19F16',
                            '#007096',
                            '#0018A8',
                            '#00A82D',
                        ];
                        var targets = flowNames.map(function (name, index) { return name + " (" + flowCounts[index] + ")"; });
                        var index = targets.indexOf(c.dataset.data[c.dataIndex].to);
                        return colors[index] || '#999';
                    },
                    colorMode: 'gradient',
                    borderWidth: 1,
                    nodeWidth: 20,
                    size: 'max',
                    priority: {
                        Backlog: 1,
                        Qualification: 1,
                        Prioritisation: 1,
                        Definition: 1,
                        Readiness: 1,
                        Implementation: 1,
                        Complete: 1,
                    },
                    labels: {
                        display: function (ctx) {
                            return ctx.raw !== targetName;
                        },
                        font: {
                            size: 20,
                            weight: 'bold',
                        },
                        formatter: function (label, ctx) {
                            var flow = ctx.dataset.data.find(function (d) { return d.from === label; });
                            return flow ? label + " (" + flow.flow + ")" : label;
                        },
                    },
                    color: function (c) {
                        if (c.type === 'node') {
                            var nodeName = c.raw;
                            if (nodeName === targetName) {
                                return '#f1f1f1';
                            }
                            var targets = flowNames.map(function (name, index) { return name + " (" + flowCounts[index] + ")"; });
                            var colors = [
                                '#888888',
                                '#671E75',
                                '#E57200',
                                '#B19F16',
                                '#007096',
                                '#0018A8',
                                '#00A82D',
                            ];
                            var index = targets.indexOf(nodeName);
                            return colors[index] || '#999';
                        }
                        return undefined;
                    },
                },
            ],
        };
        var config = {
            type: 'sankey',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: true,
                animation: {
                    duration: 2500,
                    easing: 'easeInOutQuart',
                    onComplete: function () { },
                    onProgress: function () { },
                },
                transitions: {
                    active: {
                        animation: {
                            duration: 2500,
                        },
                    },
                },
                interaction: {
                    mode: 'point',
                },
                font: {
                    size: 16,
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: false,
                    },
                    tooltip: {
                        enabled: false,
                    },
                },
            },
        };
        chartRef.current = new chart_js_1.Chart(ctx, config);
        return function () {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
        };
        // Use a value-based signature for flowCounts so a new array reference
        // with the same numbers does not destroy/recreate the Chart.js instance.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetName, flowCounts.join(',')]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("canvas", { ref: canvasRef, style: { maxHeight: '600px' } })));
};
exports.default = SankeyFlow;
